module.exports = __webpack_public_path__ + "img/IGNIS-GLX-FENIX.093dcf7c.png";